import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useMediaQuery, Theme, Box } from "@mui/material";
import { useNavigate } from "react-router";
import { SymbolV2 } from "@rentablo/api/apiv1";
import { gotToPremium, goToDashboard } from "@helpers/mainAppUrls";
import { useAppLayout } from "@providers/AppLayoutProvider";
import { AdminSidebarMenu } from "@components/common/layouts/AppSidebar/AdminSIdebarMenu/AdminSidebarMenu.tsx";
import { UserMenu } from "@components/common/layouts/AppSidebar/UserMenu.tsx";
import { FakeSearchField } from "./FakeSearchField";
import {
  AppSidebarHeader as HeaderOrig,
  AppSidebarHeaderSmall,
} from "./AppSidebarHeader";
import { Sidebar, SidebarResponsive } from "./Sidebar";
import { AppSidebarMenu } from "./AppSidebarMenu";
import { MessageBlock } from "./MessageBlock/MessageBlock";

const Header = styled(HeaderOrig)<{ collapsed?: boolean }>`
  ${({ collapsed, theme }) =>
    !collapsed &&
    css`
      margin-right: ${theme.spacing(8)};
    `}
`;

const HeaderSmallStyled = styled(AppSidebarHeaderSmall)`
  flex-grow: 1;
`;

const FakeInputWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "isSmall" && prop !== "matches" && prop !== "collapsed",
})<{
  isSmall: boolean;
  matches?: boolean;
  collapsed?: boolean;
}>`
  margin-bottom: ${({ theme, matches }) => theme.spacing(matches ? 2 : 4)};
  ${({ isSmall }) =>
    isSmall &&
    css`
      display: flex;
      align-items: center;
    `}
`;

export const AppSidebar = () => {
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { sidebarCollapsed: collapsed, toggleSidebarCollapsed } =
    useAppLayout();

  const onSymbolSelect = (symbol: SymbolV2) => {
    navigate(
      `/securities?id=${symbol.id}&quoteProvider=${symbol.quoteProvider}`
    );
  };
  if (matches) {
    return (
      <SidebarResponsive
        collapsed={collapsed}
        onMenuOpen={toggleSidebarCollapsed}
        header={
          <HeaderSmallStyled
            onTestPremiumClick={gotToPremium}
            onLogoClick={goToDashboard}
          />
        }
      >
        <FakeInputWrapper isSmall={collapsed && !matches} matches={matches}>
          <FakeSearchField
            collapsed={collapsed}
            onSymbolSelect={onSymbolSelect}
            sideBar
          />
        </FakeInputWrapper>

        <AppSidebarMenu collapsed={collapsed} />
      </SidebarResponsive>
    );
  }

  return (
    <Sidebar
      collapsed={collapsed}
      onCollapseClick={toggleSidebarCollapsed}
      header={
        <Header onTestPremiumClick={gotToPremium} onLogoClick={goToDashboard} />
      }
    >
      <FakeInputWrapper isSmall={collapsed && !matches} collapsed={collapsed}>
        <FakeSearchField
          collapsed={collapsed}
          onSymbolSelect={onSymbolSelect}
          sideBar
        />
      </FakeInputWrapper>
      <Box flex={1} display="flex" flexDirection="column" gap={2} mb={4}>
        <AppSidebarMenu collapsed={collapsed} />
        <AdminSidebarMenu />
        <MessageBlock />
      </Box>
      <UserMenu />
    </Sidebar>
  );
};
